import * as React from 'react';
import { ChangeEventHandler, MouseEventHandler } from 'react';
import cn from 'classnames';
import TextArea from '@mos-cat/text-area';

import './Form.pcss';

interface Props {
  commentary: string;
  onChange: ChangeEventHandler<HTMLTextAreaElement>;
  onSubmit: MouseEventHandler;
  className?: string;
}

const Form = ({
  onChange,
  onSubmit,
  commentary,
  className,
}: Props): JSX.Element => {
  return (
    <div className={cn('FeedbackForm', className)}>
      <TextArea
        label="Комментарий или предложение"
        value={commentary}
        name="FeedbackForm__commentary"
        maxLength={400}
        onChange={onChange}
        className="FeedbackForm__commentary"
      />
      <button
        className="mos-button mos-button_type_primary mos-button_size_small FeedbackForm__submit-form-button"
        onClick={onSubmit}
      >
        Отправить
      </button>
    </div>
  );
};

export default Form;
